import axios from '@/plugins/axios'

export default {
  async openDocument(fileId) {
    return axios.get(`files/${fileId}/download`).then(response => {
      window.open(response.data, '_blank')
    }).catch(e => {
      throw e
    })
  }
}
